export const capitalizeWords = (str) =>
  str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const formatDate = (dateStr) => {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return now.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const sanitizeSheetName = (name) => {
  return name.replace(/[:\\\/\?\*\[\]]/g, "").slice(0, 31);
};

export const getUniqueSheetName = (name, usedNames) => {
  let baseName = sanitizeSheetName(name);
  let uniqueName = baseName;
  let counter = 1;

  while (usedNames.has(uniqueName)) {
    // Ensure total length <= 31
    const suffix = `(${counter})`;
    uniqueName = baseName.slice(0, 31 - suffix.length) + suffix;
    counter++;
  }

  usedNames.add(uniqueName);
  return uniqueName;
};

export const generateRandomNo = () => {
  return Math.floor(10000000 + Math.random() * 90000000).toString();
};

export function getSession() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;

    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.currentSession;
  } catch (error) {
    return null;
  }
}
